import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { XCircleIcon } from '@heroicons/react/24/solid';

import { FINISHED_CHECKMARK } from './constants';
import type { Steps } from './steps';

type Props = {
  step: Steps;
  value: string;
  isFinished?: boolean;
  hasError?: boolean;
};

export const StepStatusCircle = ({
  step,
  value,
  isFinished,
  hasError
}: Props) => {
  if (hasError) {
    return <XCircleIcon className="w-9 text-feedback-error" />;
  }

  return isFinished ? (
    <CheckCircleIcon className="w-9" data-testid={FINISHED_CHECKMARK} />
  ) : (
    <div
      key={step}
      className="flex aspect-square w-8 items-center justify-center rounded-full border bg-white text-sm font-medium"
    >
      {value}
    </div>
  );
};
